import React, { useState, useEffect } from "react";
import "./index.scss";
import SearchIcon from "../../svgs/search.svg";
import AddCircleIcon from "../../svgs/add-circle.svg";
import StockList from "./components/StockList";
import StockAddModal from "./components/StockAddModal";
import StockUpdateModal from "./components/StockUpdateModal";
import useDebounce from "../../../Shared/GeographyFilters/hooks/useDebounce";

const Stock = () => {
  const [localSearchTerm, setLocalSearchTerm] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [showAddStockModal, setShowAddStockModal] = useState(false);
  const [showUpdateWarrantyModal, setShowUpdateWarrantyModal] = useState(false);
  const userType = JSON.parse(localStorage.getItem("currUserType"));

  const debouncedSearchTerm = useDebounce(localSearchTerm, 400);

  useEffect(() => {
    setSearchTerm(debouncedSearchTerm);
  }, [debouncedSearchTerm]);

  return (
    <div className="content-section">
      <div className="content-header">
        <div></div>
        <div className="filters-section">
          <div className="search-input">
            <img src={SearchIcon} alt="Search Icon" className="search-icon" />
            <input
              type="text"
              id="stock"
              value={localSearchTerm}
              onChange={(e) => setLocalSearchTerm(e.target.value)}
              placeholder="Search"
              className="search-input-field"
            />
          </div>
          {userType === "bkash-super-user" && (
            <>
              <button
                className="create-btn"
                onClick={() => setShowAddStockModal(true)}
              >
                <img src={AddCircleIcon} alt="Add Icon" className="btn-icon" />
                Add New Stock
              </button>
              <button
                className="create-btn"
                onClick={() => setShowUpdateWarrantyModal(true)}
              >
                <img src={AddCircleIcon} alt="Add Icon" className="btn-icon" />
                Update Warranty
              </button>
            </>
          )}
        </div>
      </div>
      <div className="content-body">
        <StockList searchTerm={searchTerm} />
      </div>

      {showAddStockModal && (
        <StockAddModal
          showAddStockModal={showAddStockModal}
          setShowAddStockModal={setShowAddStockModal}
        />
      )}
      {showUpdateWarrantyModal && (
        <StockUpdateModal
          showUpdateWarrantyModal={showUpdateWarrantyModal}
          setShowUpdateWarrantyModal={setShowUpdateWarrantyModal}
        />
      )}
    </div>
  );
};

export default Stock;
